import styled from 'styled-components'

const DesktopMainMenu = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`

export default DesktopMainMenu
